document.addEventListener("DOMContentLoaded", function () {
    const flyoutBtns = document.querySelectorAll(".flyout-button");
    const bodyOverlay = document.querySelector(".body-overlay");
    const htmlEl = document.documentElement;

    function openFlyout(flyout, triggerBtn) {
        flyout.removeAttribute("inert");
        flyout.classList.add("flyout-open");
        htmlEl.classList.add("flyout-open");
        bodyOverlay.classList.add("active");
        flyout._trigger = triggerBtn;

        // Move keyboard focus into the panel so tabbing continues
        // inside it instead of jumping past it in DOM order.
        const focusTarget = flyout.querySelector('input, a, button:not(.flyout-close)') || flyout.querySelector('.flyout-close');
        if (focusTarget) {
            focusTarget.focus();
        }
    }

    function closeFlyout(flyout) {
        flyout.classList.remove("flyout-open");
        htmlEl.classList.remove("flyout-open");
        bodyOverlay.classList.remove("active");
        flyout.setAttribute("inert", "");

        // Return focus to whichever button opened this panel.
        if (flyout._trigger) {
            flyout._trigger.focus();
        }
    }

    flyoutBtns.forEach(btn => {
        btn.addEventListener("click", function (e) {
            e.preventDefault();
            const targetId = btn.getAttribute("data-flyout-target");
            const flyout = document.querySelector(`.flyout[id="${targetId}"]`);

            if (flyout) {
                openFlyout(flyout, btn);

                const closeBtn = flyout.querySelector(".flyout-close");

                if (closeBtn) {
                    closeBtn.addEventListener("click", function (e) {
                        e.preventDefault();
                        closeFlyout(flyout);
                    });
                }

                // Stäng via Escape
                flyout.addEventListener("keydown", function (e) {
                    if (e.key === "Escape") {
                        closeFlyout(flyout);
                    }
                });

                // Stäng via overlay
                bodyOverlay.addEventListener("click", function (e) {
                    e.preventDefault();
                    closeFlyout(flyout);
                }, { once: true });
            }
        });
    });
});
//# sourceMappingURL=flyout.js.map
